// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3xk5s","fileBtn":"File_fileBtn__2TmKi","closeBtn":"File_closeBtn__11dFH","fileSelected":"File_fileSelected__3CKuF","disabled":"File_disabled__1gxiX"};